import React from "react";

const ProductSelectorButton = ({ additionalClasses = "", ...props }) => {
  const baseClasses = "productPackages__button";
  const combinedClasses = `${baseClasses} ${additionalClasses}`.trim();

  return <button data-cy="product-selector" className={combinedClasses} type="button" {...props} />;
};

export default ProductSelectorButton;
